// RelatorioStatusCard.js
import React, { useEffect, useState } from 'react';
import './RelatorioStatusCard.css';
import { getAnalyticalReportDataDetails } from '../../services/api/fetchAnalyticalReportData';

const RelatorioStatusCard = ({ reportId, onVisualizar }) => {
  const [available, setAvailable] = useState(false);
  const [reportDetails, setReportDetails] = useState(null);

  const fetchStatus = async () => {
    try {
      const data = await getAnalyticalReportDataDetails(reportId);
      if (data?.available) {
        setAvailable(true);
      }
      setReportDetails(data); 
    } catch (error) {
      console.error('Erro ao buscar status do relatório:', error);
    }
  };

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relatorio-status-card-table-wrapper">
      <table className="relatorio-status-card-table">
        <thead>
          <tr>
            <th>ID:</th>
            <th>Data Inicial:</th>
            <th>Data Final:</th>
            <th>Criação Pedido:</th>
            <th>Status:</th>
            <th>Ação:</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{reportId}</td>
            <td>{reportDetails?.date_start}</td>
            <td>{reportDetails?.date_end}</td>
            <td>{reportDetails?.created}</td>
            <td>
              <span className={available ? 'status-status-card disponivel' : 'status-status-card gerando'}>
                {available ? 'Disponível' : 'Gerando PDF...'}
              </span>
            </td>
            <td>
            <button
                className="btn-visualizar-status-card"
                disabled={!available}
                onClick={() => onVisualizar(reportId)}
            >
                Visualizar
            </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default RelatorioStatusCard;
